import { css, cx, useTheme } from '@fable/theme'
import { ReviewStar, FlexBox, Text } from '@fable/components'
import { formatRating } from './utils'

interface Props extends React.HTMLProps<HTMLDivElement> {
  rating?: number | null
  count?: number
  hideCount?: boolean
  inverted?: boolean
  hidden?: boolean
}

export const ReviewPill: React.VFC<Props> = ({
  rating = 0,
  count = 0,
  hideCount = false,
  inverted = false,
  hidden = false,
  className,
}) => {
  const { colors } = useTheme()
  const ratingScore = formatRating(rating || 0)
  const zeroRating = rating === 0 || ratingScore === '0.0'

  const getStarColor = () => {
    if (inverted) {
      return zeroRating ? colors.uiPewterGrey : colors.uiGraphite
    }

    return zeroRating ? colors.uiPewterGreyLight : colors.saffron
  }

  if (hidden && zeroRating) return null

  return (
    <FlexBox
      className={cx(
        css`
          padding: 4px 8px;
          background-color: ${inverted
            ? colors.uiPearlExtraLight
            : `${colors.blackSwan}20`};
          border-radius: 100px;
        `,
        className
      )}
      alignItems="center"
    >
      <ReviewStar
        className={css`
          margin-right: 2px;
          width: 12px;
        `}
        color={getStarColor()}
        isHalf={false}
        isEmpty={false}
      />
      {zeroRating ? null : (
        <Text
          className={css`
            font-weight: 600;
          `}
          type="label"
          sizing="L"
          color={inverted ? colors.uiGraphite : colors.whiteFang}
        >
          {ratingScore}&nbsp;
        </Text>
      )}
      {!hideCount ? (
        <Text
          type="label"
          sizing="L"
          color={inverted ? colors.uiGraphite : colors.whiteSmoke}
        >
          &#8226; {count} Reviews
        </Text>
      ) : null}
    </FlexBox>
  )
}
